export default "__VITE_ASSET__D0GZV1nq__"